import { render, staticRenderFns } from "./CommissionActionRecalculate.vue?vue&type=template&id=bfa82dc0&"
import script from "./CommissionActionRecalculate.vue?vue&type=script&lang=ts&"
export * from "./CommissionActionRecalculate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports